import { theme } from "@huub-web/ui/theme/css/theme.css";
import { rem } from "@huub-web/utils/css/rem";
import { style } from "@vanilla-extract/css";

export const timelineStyle = style({
  marginLeft: theme.spacings.s,
});

export const tipRowStyle = style({
  gap: theme.spacings.s,
  alignItems: "flex-start",
});

export const gridStyle = style({
  gap: theme.spacings.s,
});

export const scrollPaneStyle = style({
  maxHeight: rem(272),
});
